const STARTUP_STATUS = {
  approved: 'approved',
  rejected: 'rejected',
  pending: 'pending',
};

export default STARTUP_STATUS;
